module.exports = __webpack_public_path__ + "img/project2.ace2abe0.jpg";